
<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col>
                <v-card class="d-flex flex-column card-container">
                    <v-card-title class="primary--text title py-1">{{ competition.name }}</v-card-title>

                    <TeamsportCompetitionInfo v-if="competitionStatus" :competition="competition" :short="true" class="ml-4"/>

                    <!-- Spacer div to push everything below to the bottom -->
                    <div class="flex-grow-1"></div>

                    <v-card-actions class="justify-space-between">
                        <div v-if="showRegistrationProgress">
                            <v-progress-circular
                                :value="value"
                                :size="50"
                                :width="10"
                                :color="progressColor"
                            >
                                {{ spacesLeft }}
                            </v-progress-circular> {{ $translate('spaces left') }}
                        </div>
                        <v-spacer/>
                        <v-btn color="primary" @click="openDialog">
                            {{ buttonText }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TeamsportCompetitionInfo from '../components/TeamsportCompetitionInfo.vue';
export default {
    name: 'zoezi-teamsport-competition-card',

    zoezi: {
        title: 'Competition card',
        icon: 'mdi-trophy',
        addon: 'TeamSports'
    },
    props: {
        competition: {
            type: Object,
        }
    },
    components: {
        TeamsportCompetitionInfo,
    },
    data: () => ({
        showDialog: false,
    }),
    computed: {
        spacesTaken() {
            return this.competition.gameclasses
                .map(gameclass => {
                    const maxTeams = typeof gameclass.max_number_of_teams === 'number' ? gameclass.max_number_of_teams : 0;
                    const spaceLeft = typeof gameclass.spaceLeft === 'number' ? gameclass.spaceLeft : 0;

                    if (maxTeams === 0) return 0;
                    const spacesTaken = maxTeams - spaceLeft;

                    return Math.max(spacesTaken, 0);
                })
                .reduce((totalSpacesTaken, spacesTaken) => totalSpacesTaken + spacesTaken, 0);
        },

        totalAmountOfSpaces() {
            return this.competition.gameclasses
                .filter(gameclass => typeof gameclass.max_number_of_teams === 'number')
                .reduce((accumulator, gameclass) => accumulator + gameclass.max_number_of_teams, 0);
        },
        spacesLeft() {
            return this.totalAmountOfSpaces - this.spacesTaken;
        },
        value() {
            return (this.spacesTaken / this.totalAmountOfSpaces) * 100;
        },
        showRegisterButton() {
            let now = this.$store.state.now30s
            let today = Date.newFull(now.clone().yyyymmdd())
            return Date.newFull(this.competition.registrationStartDate) < today && today <= Date.newFull(this.competition.registrationEndDate);
        },
        registrationNotLimited() {
            return this.competition.gameclasses.some(gameclass => !gameclass.max_number_of_teams)
        },
        showRegistrationProgress() {
            let enoughRegistrations = this.spacesLeft / this.totalAmountOfSpaces <= 0.5;
            return !this.registrationNotLimited && this.showRegisterButton && enoughRegistrations;
        },
        progressColor() {
            const percentage = this.value
            if (percentage > 66 && percentage < 85) {
                return 'orange';
            } else if (percentage >= 85) {
                return 'red';
            } else {
                return 'green';
            }
        },
        competitionStatus() {
            let now = this.$store.state.now30s
            let today = Date.newFull(now.clone().yyyymmdd())
            let registrationStart = Date.newFull(this.competition.registrationStartDate)
            let registrationEnd = Date.newFull(this.competition.registrationEndDate)
            let competitionStart = Date.newFull(this.competition.startDate)
            let competitionEnd = Date.newFull(this.competition.endDate)
            if (registrationStart > today) {
                return 'registration-not-open';
            } else if((registrationStart <= today && registrationEnd >= today) && (this.spacesLeft > 0 || this.registrationNotLimited) && competitionStart > now) {
                return 'registration-open';
            } else if ((registrationStart <= today && registrationEnd >= today) && (this.spacesLeft <= 0) && (competitionStart > now)) {
                return 'registration-open-but-full';
            } else if (competitionStart <= now && now <= competitionEnd) {
                return 'ongoing';
            } else  {
                return 'past';
            }
        },
        buttonText() {
            switch (this.competitionStatus) {
                case 'registration-not-open':
                    return this.$translate('Read more & Watch');
                case 'registration-open':
                    return this.$translate('Read more & Register');
                case 'registration-open-but-full':
                    return this.$translate('Read more & Watch');
                case 'ongoing':
                    return this.$translate('Results & Schedule');
                case 'past':
                    return this.$translate('Results & Schedule');
                default:
                    return this.$translate('Read more & Register');
            }
        },
    },
    methods:{
        openDialog() {
            this.$emit('showDialog', this.competition.id);
        },
    },
}
</script>

<style scoped>
.card-container {
    display: flex;
    flex-direction: column;
    height: 310px;
    overflow: hidden;
}

.flex-grow-1 {
flex-grow: 1;
}

.title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
